/* Refresh.SA theme scripts (plain ES5 so it runs on older phones too) */
(function () {
  'use strict';

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }

  /* ---------- Click handlers: gallery thumbs + quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-gallery]');
      var main = gallery.querySelector('[data-gallery-main]');
      main.removeAttribute('srcset');
      main.src = thumb.getAttribute('data-full');
      main.alt = thumb.getAttribute('data-alt') || main.alt;
      $all('[data-gallery-thumb]', gallery).forEach(function (b) {
        b.setAttribute('aria-current', b === thumb ? 'true' : 'false');
      });
    }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var input = step.parentNode.querySelector('input');
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var next = (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-qty-step'), 10);
      input.value = Math.max(min, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* Cart: changing a quantity updates the cart (the "Update cart" button still works without JS) */
  var cartTimer;
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-cart-qty]')) return;
    var form = e.target.closest('form');
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () { form.submit(); }, 450);
  });

  /* ---------- Mobile menu: close on outside tap / Escape ---------- */
  $all('[data-menu]').forEach(function (menu) {
    document.addEventListener('click', function (e) {
      if (menu.open && !menu.contains(e.target)) menu.open = false;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
    });
  });

  /* ---------- Product page: variants, price, sticky bar ---------- */
  $all('[data-variant-form]').forEach(function (form) {
    var product = form.closest('[data-product]') || document;
    var data = [];
    try { data = JSON.parse(form.querySelector('[data-variant-json]').textContent); } catch (err) { return; }
    var idInput = form.querySelector('[name="id"]');
    var priceNow = product.querySelector('[data-price-now]');
    var priceWas = product.querySelector('[data-price-was]');
    var priceSave = product.querySelector('[data-price-save]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var addBtn = form.querySelector('[data-add-button]');
    var buyNow = form.querySelector('[data-buy-now]');
    var stickyAdd = document.querySelector('[data-sticky-add]');
    var gallery = product.querySelector('[data-gallery-main]');

    function update() {
      var chosen = $all('[data-option-index]:checked', form).map(function (i) { return i.value; });
      if (!chosen.length) return;
      var match = null;
      data.forEach(function (v) {
        if (!match && chosen.every(function (val, i) { return v.options[i] === val; })) match = v;
      });
      if (!match) return;

      idInput.value = match.id;
      if (priceNow) priceNow.textContent = match.price;
      if (priceWas) { priceWas.textContent = match.compare_at; priceWas.hidden = !match.on_sale; }
      if (priceSave) { priceSave.textContent = 'Save ' + match.save; priceSave.hidden = !match.on_sale; }
      if (stickyPrice) stickyPrice.textContent = match.price;
      [addBtn, buyNow, stickyAdd].forEach(function (b) { if (b) b.disabled = !match.available; });
      if (addBtn) addBtn.textContent = match.available ? addBtn.getAttribute('data-label') : 'Sold out';
      if (gallery && match.image) { gallery.removeAttribute('srcset'); gallery.src = match.image; }
      if (window.history && history.replaceState) {
        try { history.replaceState(null, '', '?variant=' + match.id); } catch (err) { /* ignore */ }
      }
    }
    $all('[data-option-index]', form).forEach(function (input) { input.addEventListener('change', update); });
    update();
  });

  (function stickyBuyBar() {
    var bar = document.querySelector('[data-sticky-buy]');
    var target = document.querySelector('[data-add-button]');
    if (!bar || !target) return;
    var stickyAdd = bar.querySelector('[data-sticky-add]');
    if (stickyAdd) stickyAdd.addEventListener('click', function () { target.click(); });

    function set(show) { bar.classList.toggle('is-visible', show); }
    if ('IntersectionObserver' in window) {
      // Show the bar once the real button has scrolled up out of view
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        set(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(target);
    } else {
      window.addEventListener('scroll', function () { set(target.getBoundingClientRect().bottom < 0); }, { passive: true });
    }
  })();

  /* ---------- Product copy: soft staggered reveal (added by JS so content is never hidden without it) ---------- */
  (function reveal() {
    var items = $all('[data-reveal]');
    if (!items.length || reduceMotion || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.15 });
    items.forEach(function (el, i) {
      el.style.setProperty('--reveal-delay', (i % 3) * 0.12 + 's');
      el.classList.add('reveal-init');
      obs.observe(el);
    });
  })();

  /* ---------- Product reviews accordion: show more + scent filter ---------- */
  $all('[data-reviews]').forEach(function (box) {
    var cards = $all('[data-review-card]', box);
    var moreBtn = box.querySelector('[data-reviews-more]');
    var filterBar = box.querySelector('[data-scent-filter]');
    var LIMIT = 4, scent = 'all', expanded = false;

    function render() {
      var shown = 0, matching = 0;
      cards.forEach(function (c) {
        var ok = scent === 'all' || c.getAttribute('data-scent') === scent;
        if (ok) matching++;
        var visible = ok && (expanded || shown < LIMIT);
        if (visible) shown++;
        c.hidden = !visible;
      });
      if (moreBtn) {
        moreBtn.hidden = expanded || matching <= LIMIT;
        moreBtn.textContent = 'Show all ' + matching + ' reviews';
      }
    }
    if (filterBar) {
      filterBar.hidden = false;
      filterBar.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-scent]');
        if (!chip) return;
        scent = chip.getAttribute('data-scent');
        expanded = false;
        $all('[data-scent]', filterBar).forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        render();
      });
    }
    if (moreBtn) moreBtn.addEventListener('click', function () { expanded = true; render(); });
    render();
  });

  /* ---------- Shared drag-to-scroll for mouse users (touch uses native swipe) ---------- */
  function enableMouseDrag(track, hooks) {
    var down = false, dragging = false, startX = 0, startScroll = 0, suppressClick = false;
    hooks = hooks || {};

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; dragging = false; startX = e.clientX; startScroll = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragging && Math.abs(dx) > 5) {
        dragging = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      }
      if (dragging) track.scrollLeft = startScroll - dx;
    });
    function end(e) {
      if (!down) return;
      down = false;
      if (dragging) {
        suppressClick = true;
        setTimeout(function () { suppressClick = false; }, 0);
        try { track.releasePointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      }
      dragging = false;
      track.classList.remove('is-dragging');
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    // A drag must not also count as a click on a card/link
    track.addEventListener('click', function (e) {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    // Stop the browser's own image/link ghost-dragging from fighting ours
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    return { isDragging: function () { return dragging; }, isDown: function () { return down; } };
  }

  /* ---------- Reviews ticker: slow auto-drift, seamless loop, swipe/drag ---------- */
  $all('[data-review-ticker]').forEach(function (track) {
    var originals = $all(':scope > *', track);
    if (!originals.length) return;
    var autoplay = track.getAttribute('data-autoplay') !== 'false' && !reduceMotion;

    // Build enough copies for a seamless loop; the copies are hidden from screen readers
    var setWidth = 0;
    function measure() {
      var first = track.children[0], firstClone = track.children[originals.length];
      setWidth = firstClone ? firstClone.offsetLeft - first.offsetLeft : track.scrollWidth;
    }
    var copies = 1 + Math.max(1, Math.ceil(track.clientWidth / Math.max(1, originals.length * 280)));
    for (var c = 0; c < copies; c++) {
      originals.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        $all('a, button', clone).forEach(function (el) { el.tabIndex = -1; });
        track.appendChild(clone);
      });
    }
    measure();
    track.scrollLeft = setWidth;           // start in the middle copy so both directions have room

    var pos = track.scrollLeft, last = pos;
    var resumeAt = 0, holding = false, hovering = false, inView = true, lastTs = 0;
    var SPEED = 26;                        // pixels per second — a slow, calm drift
    var RESUME_DELAY = 2200;

    function hold() { holding = true; }
    function release() { holding = false; resumeAt = now() + RESUME_DELAY; }

    // Touch: pause the instant a finger lands, resume a couple of seconds after it lifts
    track.addEventListener('touchstart', hold, { passive: true });
    track.addEventListener('touchend', release, { passive: true });
    track.addEventListener('touchcancel', release, { passive: true });
    // Mouse: pause while pressed or hovering
    track.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') hold(); });
    track.addEventListener('pointerup', function (e) { if (e.pointerType === 'mouse') release(); });
    track.addEventListener('pointercancel', release);
    track.addEventListener('mouseenter', function () { hovering = true; });
    track.addEventListener('mouseleave', function () { hovering = false; resumeAt = now() + RESUME_DELAY; });
    track.addEventListener('wheel', function () { resumeAt = now() + RESUME_DELAY; }, { passive: true });
    track.addEventListener('focusin', hold);
    track.addEventListener('focusout', release);

    // Any scroll we didn't cause (swipe momentum, keyboard, scrollbar) pushes the resume time back
    track.addEventListener('scroll', function () {
      if (Math.abs(track.scrollLeft - last) > 1.5) {
        pos = track.scrollLeft; last = pos;
        resumeAt = now() + RESUME_DELAY;
      }
      // keep the position inside the middle copy so it never runs out
      if (track.scrollLeft >= setWidth * 2) { track.scrollLeft -= setWidth; pos = last = track.scrollLeft; }
      else if (track.scrollLeft < setWidth * 0.5 && setWidth) { track.scrollLeft += setWidth; pos = last = track.scrollLeft; }
    }, { passive: true });

    enableMouseDrag(track);
    window.addEventListener('resize', function () { var ratio = track.scrollLeft / (setWidth || 1); measure(); track.scrollLeft = ratio * setWidth; pos = last = track.scrollLeft; });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; }).observe(track);
    }

    function tick(ts) {
      var dt = lastTs ? Math.min(ts - lastTs, 50) : 16;
      lastTs = ts;
      if (autoplay && inView && !holding && !hovering && !document.hidden && now() >= resumeAt) {
        // Keep our own fractional position: scrollLeft rounds to whole pixels on many screens,
        // so adding a fraction directly to it would never move.
        pos += SPEED * dt / 1000;
        track.scrollLeft = pos;
        last = track.scrollLeft;
      } else {
        pos = track.scrollLeft; last = pos;   // stay in sync with wherever the visitor left it
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  });

  /* ---------- Bundles carousel: swipe / drag, arrows, progress bar. No auto-play. ---------- */
  $all('[data-bundles-track]').forEach(function (track) {
    var section = track.closest('section');
    var prevBtn = section.querySelector('[data-bundles-prev]');
    var nextBtn = section.querySelector('[data-bundles-next]');
    var thumb = section.querySelector('[data-bundles-progress-thumb]');

    enableMouseDrag(track);

    function stepSize() {
      var card = track.querySelector('.bundle-card');
      return card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: stepSize(), behavior: 'smooth' }); });

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 2;
      if (!thumb) return;
      if (max <= 0) { thumb.style.width = '100%'; thumb.style.transform = 'translateX(0)'; return; }
      var ratio = track.clientWidth / track.scrollWidth;
      var p = track.scrollLeft / max;
      thumb.style.width = Math.max(ratio * 100, 12) + '%';
      thumb.style.transform = 'translateX(' + (p * (100 / Math.max(ratio, .12) - 100)) + '%)';
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
